/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

!function (e) {
    e.fn.serializeObject = function () {
        var i = this, t = {}, a = {}, n = {
            validate: /^[a-zA-Z][a-zA-Z0-9_]*(?:\[(?:\d*|[a-zA-Z0-9_]+)\])*$/,
            key: /[a-zA-Z0-9_]+|(?=\[\])/g,
            push: /^$/,
            fixed: /^\d+$/,
            named: /^[a-zA-Z0-9_]+$/
        };
        return this.build = function (e, i, t) {
            return e[i] = t, e
        }, this.push_counter = function (e) {
            return void 0 === a[e] && (a[e] = 0), a[e]++
        }, e.each(e(this).serializeArray(), function () {
            if (n.validate.test(this.name)) {
                for (var a, u = this.name.match(n.key), h = this.value, r = this.name; void 0 !== (a = u.pop());) r = r.replace(new RegExp("\\[" + a + "\\]$"), ""), a.match(n.push) ? h = i.build([], i.push_counter(r), h) : a.match(n.fixed) ? h = i.build([], a, h) : a.match(n.named) && (h = i.build({}, a, h));
                t = e.extend(!0, t, h)
            }
        }), t
    }
}(jQuery);

/*! productCombo.js
*/

(function ProductCombo() {
    'use strict';
    // Context
    var context = {products: {}};
    // Regex for tags
    var regex = new RegExp("^combo\/(.*)");
    // Template source
    var source = $("#combo-product-template").html();
    // Handlebars
    var template = Handlebars.compile(source);
    // The config props
    var config = JSON.parse(document.querySelector('[data-combo-config]').innerHTML);
    // Recommendations
    var recommendations = [config.product.handle].concat(config.product.tags.filter(tag => regex.test(tag)).map(tag => tag.replace(/combo\//, '')));

    var soldout = config.product.tags.indexOf('theme/soldout') > 0;
    // Nodes id`s
    var container = config.containerId;
    var form = config.formId;

    function registerBlockHelpers() {
        Handlebars.registerHelper('ifEqual', function (a, b, options) {
            if (a === b) {
                return options.fn(this);
            }
            return options.inverse(this);
        });
        Handlebars.registerHelper('ifNotEqual', function (a, b, options) {
            if (a !== b) {
                return options.fn(this);
            }
            return options.inverse(this);
        });
        Handlebars.registerHelper('assign', function (varName, varValue, options) {
            if (!options.data.root) {
                options.data.root = {};
            }
            options.data.root[varName] = varValue;
        });
        Handlebars.registerHelper("inc", function (value, options) {
            return parseInt(value) + 1;
        });
    }

    function getProductByHandle(handle) {
        return jQuery.getJSON(`/products/${handle}.js`);
    }

    async function refreshContextData() {
        return await Promise.all(recommendations.map(async (handle) => {
            return await getProductByHandle(handle);
        })).then(response => {
            context.products = response;
            return context;
        });
    }

    function handleOnChangeProductOption(context) {
        // console.log('handleOnChangeProductOption');
        return (e) => {
            var node = $(e.target);
            var optionChanged = node.attr('data-position');
            var options = node.closest("form").serializeArray();
            var id = $(e.target).closest("form").attr('data-comboproduct');
            // Selected product
            var product = context.products.find(product => product.id.toString() === id.toString());
            // Selected variant
            var variant = product.variants.find(variant => {
                const optionsResults = options.map(option => {
                    return (variant[option.name].toString() === option.value.toString());
                });
                return optionsResults.every(result => result === true);
            });
            // Update form
            $(`form input#${product.id}-variant`).val(variant.id);
            $(`form input#${product.id}-variant-available`).val(variant.available);
            $(`form input#${product.id}-variant-inventory-quantity`).val(variant.inventory_quantity);
            $(`form input#${product.id}-variant-inventory_policy`).val(variant.inventory_policy);
            $(`form input#${product.id}-variant-title`).val(variant.title);
            // Set stock
            $(e.target).closest("form").trigger("combo.productselected", [product, optionChanged]);
        }
    }

    function groupBy(xs, key) {
        return xs.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    }

    function toogleProductOptionStatus(productId, name, value, enabled = true) {
        var disabledClass = "out-of-stock";
        if (enabled) {
            $(`form[data-comboproduct="${productId}"]`).find(`input[name="${name}"][value="${value}"].out-of-stock`).removeClass(disabledClass);
        } else {
            $(`form[data-comboproduct="${productId}"]`).find(`input[name="${name}"][value="${value}"]`).addClass(disabledClass);
        }
    }

    function lookupForOutOfStock(product, optionIndex) {
        // optionIndex = 1;
        var formData = $(`form[data-comboproduct="${product.id}"]`).serializeArray().map(obj => obj.value);
        var optionObject = product.options.find(option => option.position == optionIndex);
        var hasNextOption = product.options.find(option => option.position == optionIndex + 1);
        var outOfStockVariants = product.variants.filter(variant => {
            if (optionIndex === 1) return (variant.available === false);
            var sliceStop = optionIndex - 1;
            var selectedOptionsStr = formData.slice(0, sliceStop).join();
            var compareOptionsStr = variant.options.slice(0, sliceStop).join();
            return ((selectedOptionsStr == compareOptionsStr) && variant.available === false);
        });

        var disableOnQty = (optionIndex == 1 && product.options.length > 1) ? product.options.filter((value) => value.position !== optionIndex).map((a) => a.values.length).reduce((a, b) => a * b) : (optionIndex == 2) ? optionObject.values.length : 1;
        var grouppedByOption = groupBy(outOfStockVariants, `option${optionIndex}`);
        optionObject.values.map((value) => {
            if (value in grouppedByOption && grouppedByOption[value].length >= disableOnQty) {
                // if (value in grouppedByOption && typeof grouppedByOption[value] !== 'undefined' && !grouppedByOption[value].enabled) {
                toogleProductOptionStatus(product.id, `option${optionIndex}`, value, false);
            } else {
                toogleProductOptionStatus(product.id, `option${optionIndex}`, value, true);
            }
        });
        if (hasNextOption) lookupForOutOfStock(product, optionIndex + 1);
    }

    function handleToggleOptions() {
        return (e, product, optionPositionChanged = '1') => {
            lookupForOutOfStock(product, 1);
            toggleAddToCartButton();
        }
    }

    function selectFirstAvailable(context) {
        context.products.forEach(product => {
            var availableVariants = product.variants.filter(variant => {
                return (variant.available === true);
            });

            if (availableVariants.length > 0) {
                availableVariants[0].options.forEach(option => {
                    $('.sub-swatches .swatch-element input[value="' + option + '"][id*="' + product.handle + '"]:not(".out-of-stock")').click();
                });
            }
        });

        toggleAddToCartButton();
    }

    function toggleAddToCartButton() {
        var itstrue = true;
        $(`form.form-ajaxtocart`).find(`input[name="available"]`).each(function (i) {
            if ($(this).val() !== 'true') {
                itstrue = false;
            }
        });
        var policy_continue = false;
        $(`form.form-ajaxtocart`).find(`input[name="inventory"]`).each(function (i) {
            if ($(this).val() == "continue") {
                policy_continue = true;
            }
        });
        var inv_qty = false;
        $(`form.form-ajaxtocart`).find(`input[name="inv_qty"]`).each(function (i) {
            if (0 < $(this).val()) {
                inv_qty = true;
            }
        });
      
        if(soldout) itstrue = false;

        if (itstrue) {
            // const variant = possibleVariants[index];
            // const input = document.querySelector(`[value="${variant.option1}"]`);
            // if (!variant.available) {
            //     add_to_cart_text.classList.add('hidden');
            //     book_now_text.classList.add('hidden');
            //     sold_out_text.classList.remove('hidden');
            //     sold_out_text_info.classList.add('hidden');
            //     input.classList.add('unavailable');
            //     input.classList.add('hidden');
            //     if (esc_oos_form_app) esc_oos_form_app.classList.remove('hidden');
            // } else {
            //     if(variant.inventory_policy == "continue" && variant.inventory_quantity < 0) {
            //         book_now_text.classList.remove('hidden');
            //         sold_out_text_info.classList.remove('hidden');
            //     } else {
            //         book_now_text.classList.add('hidden');
            //         sold_out_text_info.classList.add('hidden');
            //     }
            //     add_to_cart_text.classList.remove('hidden');
            //     sold_out_text.classList.add('hidden');
            //     input.classList.remove('unavailable');
            //     if (esc_oos_form_app) esc_oos_form_app.classList.add('hidden');
            // }

            const sold_out_text = document.querySelector('#sold_out_text');
            const sold_out_text_info = document.querySelector('#sold_out_text_info');
            const book_now_text = document.querySelector('#book_now_text');
            const add_to_cart_text = document.querySelector('#add_to_cart_text');
            const esc_oos_form_app = document.querySelector('#esc-oos-form-app');

            if (policy_continue && !inv_qty ) {
                //Disable form
                $(".AddToCartForm").addClass("no-stock pre-order");
                $("#sold_out_text").removeClass("hidden");
                $("#sold_out_text_info").removeClass("hidden");
                $("#add_to_cart_text").addClass("hidden");
                $(".product-right-column .order_deadline_countdown").removeClass("visible");
                $("#esc-oos-form").addClass("hidden");
                $(".AddToCart.product-form__submit.button").prop("disabled", false);

                book_now_text.classList.remove('hidden');
                sold_out_text_info.classList.remove('hidden');
                add_to_cart_text.classList.remove('hidden');
                sold_out_text.classList.add('hidden');
                // input.classList.remove('unavailable');
                // if (esc_oos_form_app) esc_oos_form_app.classList.add('hidden');
                // console.log("no hay, continue");
                // $(".BookToCart.product-form__submit").addClass("visible").removeClass("hidden");
                // $(".sold-out.product-form__submit").removeClass("visible").addClass("hidden");
            } else {
                //Disable form
                $(".AddToCartForm").removeClass("pre-order").addClass("no-stock");
                $("#sold_out_text").addClass("hidden");
                $("#sold_out_text_info").addClass("hidden");
                $("#add_to_cart_text").removeClass("hidden");
                $(".product-right-column .order_deadline_countdown").removeClass("visible");
                $("#esc-oos-form").removeClass("hidden");
                $(".AddToCart.product-form__submit.button").prop("disabled", false);
                // console.log("hay");
                // $(".sold-out.product-form__submit").removeClass("visible").addClass("hidden");
            }
        } else {
            $("#sold_out_text").removeClass("hidden");
            $("#sold_out_text_info").addClass("hidden");
            $("#add_to_cart_text").addClass("hidden");
            // $(".AddToCart.product-form__submit.button").prop("disabled", true);
            // console.log("no hay");
            // $(".sold-out.product-form__submit").addClass("visible").removeClass("hidden");
            // $(".AddToCart.product-form__submit").removeClass("visible").addClass("hidden");
        }
    }

    function generateUniqueString(prefix) {
        var ts = String(new Date().getTime()),
            i = 0,
            out = '';
        for (i = 0; i < ts.length; i += 2) {
            out += Number(ts.substr(i, 2)).toString(36);
        }
        return (prefix + '-' + out);
    }

    function handleOnClickBuyButton(e) {
        e.preventDefault();
        var submitForm = document.querySelector('[data-type="add-to-cart-form"]');
        var submitButton = submitForm.querySelector('[type="submit"]');
        var spinner = submitForm.querySelector('.loading-overlay__spinner');

        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
        spinner.classList.remove('hidden');

        var comboId = generateUniqueString('combo');
        var talla = "";
        var data = context.products.map(product => {
            var object = $(`form#product-${product.id}`).serializeObject();
            if (product.price == 0) {
                talla += object.title.trim().toUpperCase();
            } else {
                var variant_titles = object.title.split('/');
                talla += variant_titles[0].trim().toUpperCase() + ' / ';
            }
            return {
                id: object.id,
                quantity: object.quantity,
                properties: {
                    Conjunto: comboId
                }
            }
        });

        $.each(data, function (index, item) {
            item.properties.Talla = talla;
        });

        var cart = CartJS.cart, in_cart = 0;
        var items = [];
        var pairs = [];
        if(cart.items){
            items = cart.items.filter((item) => !jQuery.isEmptyObject(item.properties));
        }
        $.each(items, function (index, item) {
            if (typeof pairs[item.properties.Conjunto] === "undefined") {
                pairs[item.properties.Conjunto] = 1;
                if (item.id == data[0].id || item.id == data[1].id) {
                    in_cart++
                }
            } else {
                if (item.id == data[0].id || item.id == data[1].id) {
                    in_cart++
                }
                pairs[item.properties.Conjunto]++;

                if (in_cart == 2) return false;
                else in_cart = 0;
            }
        });

        if(in_cart == 0 || in_cart % 2 != 0) {
            data = data.reverse();

            CartJS.addItems(data, {
                "success": function (data, textStatus, jqXHR) {
                    fetch(`${routes.cart_url}`)
                        .then((response) => response.text())
                        .then((responseText) => {
                            const cart_id = `shopify-section-cart-drawer`;
                            const bubble_id = `cart-icon-bubble`;
                            const html = new DOMParser().parseFromString(responseText, 'text/html')
                            const cart_source = html.getElementById(cart_id).outerHTML;
                            const bubble_source = html.getElementById(bubble_id).innerHTML;

                            var new_cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                            var formData = data.items[0],
                                sections = new_cart.getSectionsToRender();
                            formData.sections = {};

                            sections.forEach( function(valor, indice, array) {
                                if (valor.id == "cart-icon-bubble") {
                                    formData.sections[valor.id] = `<div id="shopify-section-cart-icon-bubble" class="shopify-section">${bubble_source}</div>`;
                                } else if (valor.selector) {
                                    let div = document.querySelector("#shopify-section-" + valor.id);
                                    if(new_cart.classList.contains('is-empty')) {
                                        div.querySelector(".drawer__inner-empty").remove();
                                        div.querySelectorAll(".is-empty").forEach(box => {
                                            box.classList.remove('is-empty');
                                        });
                                    }
                                    formData.sections[valor.id] = cart_source;
                                }
                            });

                            formData.sections_url = window.location.pathname;
                            new_cart.setActiveElement(document.activeElement);
                            // console.log(formData);
                            // ajaxUpdateCart();
                            new_cart.renderContents(formData);

                            submitButton.classList.remove('loading');
                            submitButton.removeAttribute('aria-disabled');
                            spinner.classList.add('hidden');

                            // const cartLink = document.querySelector('#cart-icon-bubble');
                            // cartLink.click();
                            // var overlay = $('#shoppingcart');
                            // overlay.toggleClass('visible');
                            // $('body').css('overflow-y', 'hidden');
                        });
                },
                "error": function (jqXHR, textStatus, errorThrown) {
                    submitButton.classList.remove('loading');
                    submitButton.removeAttribute('aria-disabled');
                    spinner.classList.add('hidden');

                    var response = $.parseJSON(jqXHR.responseText);
                    // $('#notification-message').text(response.message + ': ' + response.description);
                    // $('#notification-container').addClass('notification-visible');
                    // setTimeout(function () {
                    //     $('#notification-container').removeClass('notification-visible');
                    // }, 5000);
                    handleErrorMessage(response.message + ': ' + response.description);
                    console.log('error');
                    console.log(response.message + ': ' + response.description);
                }
            });
        } else {
            // console.log('fail');
            console.log('Ya has añadido esta variante al carrito');
            handleErrorMessage('Ya has añadido esta variante al carrito');

            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
            spinner.classList.add('hidden');

            // $('#notification-message').text('Ya has añadido esta variante al carrito');
            // $('#notification-container').addClass('notification-visible');
            // setTimeout(function () {
            //     $('#notification-container').removeClass('notification-visible');
            // }, 5000);
        }
    }

    function handleErrorMessage(message = false) {
        const errorMessageWrapper = document.querySelector('.product-form__error-message-wrapper');
        if (!errorMessageWrapper) return;
        let errorMessage = errorMessageWrapper.querySelector('.product-form__error-message');

        errorMessageWrapper.toggleAttribute('hidden', !message);

        if (message) {
            errorMessage.textContent = message;
        }
    }

    /*
        function ajaxUpdateCart() {
            var ajax = new XMLHttpRequest();
            ajax.onreadystatechange = function () {
                if (ajax.readyState == 4 && ajax.status == 200) {
                    var response = JSON.parse(ajax.responseText);

                    if ($('#cart-form .cart-product.hidden').length > 0) {
                        $('.order-summary-savings .original').html(Shopify.formatMoney(response.original_total_price));
                        $('.order-summary-savings .discount').html('-' + Shopify.formatMoney(response.total_discount));
                        $('.order-subtotal-total-value').html(Shopify.formatMoney(response.total_price));
                    }

                    var cart_item_count = response.item_count;
                    $.each(response.items, function (index, item) {
                        if (parseInt(item.price) <= 0) {
                            cart_item_count = cart_item_count - item.quantity;
                        }
                    });

                    $('.cart-total-price').text(Shopify.formatMoney(response.total_price));
                    $('.cart__count').text(cart_item_count);
                    $('.customer-popup .price .h2').html(Shopify.formatMoney(response.total_price));

                    if (response.item_count <= 0) {
                        $('#empty_cart_row').removeClass('hidden');
                        $('.customer-popup .box').addClass('hidden');
                    } else {
                        var cleanItems, pr_product = $('#shopify-section-cart-promo-product'),
                            itemcart = $('.cart-product.customer-grid-item.hidden:not(#pr-product)'), has_product = false;

                        pr_product.find('#pr-product').addClass('hidden');

                        cleanItems = $('.cart-product.customer-grid-item:not(.hidden), .combo-discount');
                        cleanItems.remove();

                        var has_combo = false;
                        var hidden_item = false;

                        $.each(response.items, function (line_number, item) {

                            if (parseInt(item.price) <= -10) {
                                hidden_item = true;
                            } else {
                                hidden_item = false;
                            }

                            if (!hidden_item) {
                                if (item.handle == $('#pr-product').data('handle')) {
                                    has_product = true;
                                }

                                var itemclone = itemcart.clone();
                                itemclone.find('.add-product-title').html(item.product_title);

                                if (!jQuery.isEmptyObject(item.properties)) {
                                    $.each(item.properties, function (index, property) {
                                        if (index == 'Talla') {
                                            itemclone.find('.add-variant-title').html(property);
                                        } else if (index == 'Conjunto') {
                                            itemclone.append($('<input type="hidden" name="combo-id" data-line="' + (line_number + 1) + '" data-id="' + item.id + '" value="' + property + '"/>'));
                                        }
                                    });
                                } else {
                                    if (item.variant_title != null && item.variant_title != 'Default Title') {
                                        if (item.variant_title.includes("Unidad")) {
                                            itemclone.find('.add-variant-title').html(item.variant_title);
                                        } else {
                                            var variant = item.variant_title.toLowerCase().replace(/ /g, '-').replace(/€/g, '-').split('-');
                                            var isnum = /^\d+$/.test(variant[0]);

                                            if (!isnum) {
                                                var variant_titles = item.variant_title.split('/');
                                                var v_title = '';

                                                $.each(variant_titles, function (index, variant_title) {
                                                    if (index == (variant_titles.length - 1)) {
                                                        if (has_combo) {
                                                            v_title += ' / ' + has_combo;
                                                        } else {
                                                            var variant_color = variant_title.trim().replace(/\-/g, ' ')
                                                            v_title += ' - ' + variant_color.charAt(0).toUpperCase() + variant_color.slice(1);
                                                        }
                                                    } else {
                                                        if (index != 0) {
                                                            v_title += ' / ' + variant_title.trim().toUpperCase();
                                                        } else {
                                                            v_title += variant_title.trim().toUpperCase();
                                                        }
                                                    }
                                                });
                                                itemclone.find('.add-variant-title').html(v_title);
                                            }
                                        }
                                    }
                                }

                                if (item.original_line_price != item.line_price) {
                                    itemclone.find('.discount-value').html(Shopify.formatMoney(item.original_price));
                                    itemclone.find('.add-price').addClass('discount').html(Shopify.formatMoney(item.price));
                                } else {
                                    itemclone.find('.add-price').html(Shopify.formatMoney(item.line_price));
                                }

                                itemclone.find('.add-price').html(Shopify.formatMoney(item.line_price));
                                itemclone.find('.add-item-url').attr('href', item.url);
                                if (typeof item.image !== "undefined" && item.image !== null)
                                    itemclone.find('.customer-grid-item-image').css('background', 'url(' + item.image.imgURL('small') + ') center center / cover');
                                else
                                    itemclone.find('.customer-grid-item-image').css('background', '#ccc');
                                itemclone.find('.remove-item').data('id', item.id).data('handle', item.handle).data('key', item.key).attr('href', "/cart/change?id=" + item.id + "&amp;quantity=0");
                                itemclone.find('.qty-btn').data('id', item.id).data('handle', item.handle).data('key', item.key);
                                itemclone.find('.quantity').data('id', item.id).attr('value', item.quantity).attr('data-line', line_number + 1);
                                itemclone.insertBefore(pr_product).removeClass("hidden");

                                if (!jQuery.isEmptyObject(item.properties)) {
                                    $.each(item.properties, function (index, property) {
                                        if (index == 'Conjunto') {
                                            itemclone.append($('<input type="hidden" name="combo-id" data-line="' + (line_number + 1) + '" data-id="' + item.id + '" value="' + property + '"/>'));
                                        }
                                    });
                                }

                                if (response.item_count > 1) {
                                    $('.has-one.custom-text').addClass('hidden');
                                    $('.has-more.custom-text').removeClass('hidden');
                                } else {
                                    $('.has-more.custom-text').addClass('hidden');
                                    $('.has-one.custom-text').removeClass('hidden');
                                }
                                has_combo = false;
                            }
                        });

                        if (!has_product && !$('#pr-product').hasClass('empty')) {
                            $('#pr-product').removeClass('hidden');
                        }

                        $('#empty_cart_row').addClass('hidden');
                        $('.customer-popup .box').removeClass('hidden');
                    }

                    $('#cart__grid__loader').hide();
                }
            };
            ajax.open("GET", "/cart.js", true);
            ajax.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            ajax.send();
        }
    */

    function init() {
        refreshContextData().then(context => {
            // Register helpers
            registerBlockHelpers();
            // Render
            $('#' + container).append(template(context));
            // On change options
            $('#' + container + ' [data-comboproduct]').on("change", handleOnChangeProductOption(context));
            $('#' + container + ' [data-comboproduct]').on("combo.productselected", handleToggleOptions());
            // On send form
            // $('#'+container+' #combo-form').submit(handleOnClickBuyButton);
            $(document).on('click', '.product-form__submit', handleOnClickBuyButton);
            // init "stock" flags
            context.products.forEach(product => lookupForOutOfStock(product, 1));
            selectFirstAvailable(context);
        });

    }

    init()
})();
